module.exports = __webpack_public_path__ + "static/media/innocent-2.4fea5cc0.png";